import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { companyInfo, navItems } from "../data/siteContent";
import { FaChevronDown } from "react-icons/fa6";

export default function TopBar() {
  const appContext = useContext(AppContext);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 30);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function goTo(item) {
    appContext.navTo({ item });
  }

  function isActive(item) {
    if (item.dropdown) {
      return item.dropdown.some((entry) => entry.item === appContext.navItem);
    }

    return item.item === appContext.navItem || (item.item === "home" && !appContext.navItem);
  }

  return (
    <div className={`TopBar ${scrolled ? "scrolled" : ""}`}>
      <div className="body">
        <div className="container d-flex justify-content-between">
          <div
            className="align-self-center d-flex"
            style={{ height: "100%", flexShrink: 1 }}
          >
            <div
              className="d-flex align-items-center gap-2"
              style={{ cursor: "pointer" }}
              onClick={() => appContext.navTo({ item: "home" })}
            >
              <img
                src={companyInfo.logo}
                alt={companyInfo.shortName}
                style={{ height: "70px", width: "auto", flexShrink: 0 }}
                className="align-self-center"
              />
              {/* <div className="ags-navbar-brand-copy">
                <div className="font-bold text-primary" style={{ lineHeight: 1 }}>
                  {companyInfo.shortName}
                </div>
                <small style={{ color: "var(--onSurfaceColor)", opacity: 0.7 }}>
                  Africa Geospatial Solutions
                </small>
              </div> */}
            </div>
          </div>

          <div
            className="DesktopMenu d-none d-lg-flex align-items-center my-4"
            style={{ height: "100%", width: "auto", flexShrink: 1, minWidth: 0 }}
          >
            {navItems.topLevel.map((item) => (
              <div
                key={item.label}
                className={`mMenuItem ${item.dropdown ? "ags-menu-dropdown" : ""}`}
                onClick={() => goTo(item.item)}
                data-active={isActive(item)}
              >
                <span>{item.label}</span>
                {item.dropdown ? <FaChevronDown size={12} /> : null}

                {item.dropdown ? (
                  <div className="ags-dropdown-menu">
                    {item.dropdown.map((entry) => (
                      <button
                        type="button"
                        key={entry.label}
                        className="ags-dropdown-link"
                        onClick={(event) => {
                          event.stopPropagation();
                          goTo(entry.item);
                        }}
                      >
                        {entry.label}
                      </button>
                    ))}
                  </div>
                ) : null}
              </div>
            ))}

          </div>
        </div>
      </div>
    </div>
  );
}
